import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { AnsweringSearchListingsDTO } from '@bb/domain/dist/types';
import type { OrgDetailsType, RepType } from 'components/UniversalSearch/types';

const findAnsweringListings = async ({
  search,
  mlsTypes,
  repId,
  page = 0,
  pageSize,
}: {
  search: string;
  repId?: string;
  mlsTypes?: string[];
  page?: number;
  pageSize?: number;
}) => {
  const config: AxiosRequestConfig = {
    url: `/answering/listings/${page}`,
    method: 'GET',
    params: {
      search,
      repId,
      mlsTypes,
      pageSize,
    },
  };

  const { data } = await axios.request<{
    listings: (AnsweringSearchListingsDTO & {
      mlsTypes: string[];
      reps: RepType[];
      org: OrgDetailsType;
      preBookingInformation?: string;
    })[];
    count: number;
  }>(config);

  return data;
};

export default findAnsweringListings;
